/** Decodifica un nombre de archivo que puede venir URL-encoded (p. ej. `%20`
 *  por espacios, como lo devuelve el storage/`nombreArchivo`). Si no es
 *  decodificable (un `%` suelto que no forma una secuencia válida), retorna el
 *  nombre tal cual en vez de lanzar. */
export function decodeFileName(name: string): string {
  try {
    return decodeURIComponent(name);
  } catch {
    return name;
  }
}
